import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Project} from '../../shared/models/project';

@Component({
    selector: 'mbnm-rotation-violation-dialog',
    templateUrl: './rotation-violation-dialog.component.html',
    styleUrls: ['./rotation-violation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RotationViolationDialogComponent implements OnInit {

  public project: Project;
  constructor() { }

  ngOnInit(): void {
  }

}
